<p class="total-results" [hidden]="totalResults === 0">
  Showing {{ displayedResults }} of {{ totalResults }} results
</p>
<ng-template #rt let-r="result" let-t="term">
  <div id="typeaheadResult">
    <div class="display-flex">
      <ngb-highlight [result]="r.Plant.Symbol" [term]="t"></ngb-highlight>&nbsp;&nbsp;
      <div [innerHTML]="r.Plant.ScientificName | boldSearch: t"></div>
      @if (r.Plant.CommonName) {
        <div>,&nbsp;</div>
      }
      <ngb-highlight [result]="r.Plant.CommonName" [term]="t"></ngb-highlight>
    </div>
  </div>
</ng-template>
<div class="display-flex flex-justify-start flex-align-end">
  <label for="find-a-plant" class="usa-sr-only">Find A Plant Input</label>
  <input
    id="find-plant"
    name="find-plant"
    type="text"
    class="usa-input"
    [(ngModel)]="searchAheadText"
    [ngbTypeahead]="search"
    [resultTemplate]="rt"
    [focusFirst]="false"
    [inputFormatter]="inputFormatter"
    (selectItem)="onSelect($event)"
    placeholder="Find a plant..."
    [attr.aria-controls]="typeAheadId"
  />
  <div>
    @if (hasSelectedResult) {
      <button
        type="button"
        class="usa-button usa-button--outline usa-button--inverse"
        (click)="performSearch()"
      >
        View
      </button>
    }
  </div>
  @if (isLoading) {
    <span class="text-center"
      ><i class="fa fa-refresh fa-spin" aria-hidden="true"></i> Loading</span
    >
  }
</div>
@if (isSearching) {
  <span><i class="fa fa-refresh fa-spin" aria-hidden="true"></i> Searching...</span>
}
@if (noResults) {
  <div class="alert alert-danger rounded-0 mt-1 p-1">No results found</div>
}
